var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGigitalGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#16b287",
    height: "55px",
    width: "55px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    stroke: "#16b287",
    strokeWidth: 0.00512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M511.755,391.412L478.2,253.962c-0.939-3.846-4.386-6.553-8.345-6.553h-83.403l-31.956-130.897 c-0.939-3.846-4.386-6.553-8.345-6.553H165.852c-3.96,0-7.406,2.707-8.346,6.553l-9.168,37.556 c-1.125,4.609,1.699,9.258,6.308,10.383c4.613,1.128,9.258-1.7,10.383-6.308l7.568-31.003h166.807l29.36,120.269H143.235 l14.48-59.313c1.125-4.609-1.699-9.258-6.308-10.383c-4.609-1.124-9.258,1.7-10.383,6.308L125.55,247.41H42.147 c-3.96,0-7.406,2.707-8.346,6.553L0.245,391.412c-0.625,2.562-0.04,5.269,1.589,7.343s4.12,3.285,6.757,3.285h392.88 c4.744,0,8.591-3.846,8.591-8.591c0-4.744-3.846-8.591-8.591-8.591H266.94l29.362-120.268h166.807l29.36,120.268h-60.071 c-4.744,0-8.591,3.846-8.591,8.591c0,4.744,3.846,8.591,8.591,8.591h71.012c2.637,0,5.128-1.211,6.757-3.285 C511.795,396.681,512.38,393.974,511.755,391.412z M19.531,384.859l29.362-120.268h166.807l29.36,120.268H19.531z M256,357.227 l-22.615-92.637h45.231L256,357.227z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGigitalGold);
export default __webpack_public_path__ + "static/media/GigitalGold.4e590fd70237f0db31779d8419e18405.svg";
export { ForwardRef as ReactComponent };